module.exports = __webpack_public_path__ + "img/ug516.296e8305.png";